import React, { useState } from 'react';

const FAQ_ITEMS = [
  {
    id: 1,
    question: 'How can I track my order?',
    answer: 'Once your order ships, you’ll receive an email with a tracking link. You can also log into your account and visit Order History to see status and tracking for all your orders.',
  },
  {
    id: 2,
    question: 'What is your return and exchange policy?',
    answer: 'We offer hassle-free returns within 30 days of delivery. Items must be unworn, with tags attached, and in original packaging. Exchanges are subject to availability—contact our team and we’ll guide you through the process.',
  },
  {
    id: 3,
    question: 'Do you ship internationally?',
    answer: 'Yes. We ship to select countries worldwide. Shipping costs and delivery times vary by destination and are calculated at checkout. Customs and duties may apply depending on your location.',
  },
  {
    id: 4,
    question: 'How do I care for my garments?',
    answer: 'Care instructions are on the label inside each piece. We recommend gentle washing or dry cleaning where indicated, and storing in a cool, dry place to preserve quality and longevity.',
  },
  {
    id: 5,
    question: 'Where can I find my size?',
    answer: 'Each product page includes a size guide. We recommend measuring yourself and comparing to our charts for the best fit. If you’re between sizes, our team is happy to advise—reach out via the contact page.',
  },
];

const FAQSection = () => {
  const [openId, setOpenId] = useState<number | null>(FAQ_ITEMS[0].id);

  return (
    <section id="faq" className="w-full py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-hero font-medium text-wine font-display">
            Frequently Asked Questions
          </h2>
        
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="rounded-2xl overflow-hidden border border-beige-dark/50 bg-white transition-all duration-300 hover:shadow-[0_8px_28px_rgba(98,41,53,0.1)]"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-4 sm:py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-wine focus-visible:ring-offset-2 rounded-2xl"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${item.id}`}
                  id={`faq-question-${item.id}`}
                >
                  <span className="font-display font-medium text-[var(--color-black)] text-base sm:text-lg pr-2">
                    {item.question}
                  </span>
                  <span
                    className={`flex-shrink-0 w-8 h-8 rounded-full bg-beige flex items-center justify-center text-wine transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                    aria-hidden
                  >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </button>
                <div
                  id={`faq-answer-${item.id}`}
                  role="region"
                  aria-labelledby={`faq-question-${item.id}`}
                  className="grid transition-[grid-template-rows] duration-300 ease-out"
                  style={{
                    gridTemplateRows: isOpen ? '1fr' : '0fr',
                  }}
                >
                  <div className="overflow-hidden">
                    <div className="px-5 sm:px-6 pb-4 sm:pb-5 pt-0">
                      <p className="font-body text-[var(--color-black)]/90 text-sm sm:text-base leading-relaxed border-t border-beige-dark/40 pt-4">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
